// extracted by mini-css-extract-plugin
export default {"linkedinBtn":"LinkedinButton_linkedinBtn__9e2qW","socialIcon":"LinkedinButton_socialIcon__flxDg"};